import 'babel-polyfill';
// Enable fetch on IE11
import 'whatwg-fetch';
import smoothscroll from 'smoothscroll-polyfill';
import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createStore from '../mail-to-target/create-store';
import Container from '../mail-to-target/container';
import { compileInitialState } from '../mail-to-target/helpers';

smoothscroll.polyfill();

document.addEventListener('DOMContentLoaded', () => {
  const pageData = JSON.parse(
    document.getElementById('page-data').getAttribute('data')
  );

  // TODO: Does all of this state need to be managed by Redux? Much of it will
  // be static, so think about another way to provide it to React components
  const initialState = compileInitialState(pageData, window.location);

  const store = createStore(initialState);

  const releaseVersonElement = document.head.querySelector(
    "[name='release-version']"
  );

  const appVersion =
    (releaseVersonElement &&
      releaseVersonElement.attributes['content'].value) ||
    undefined;

  Bugsnag.start({
    apiKey: import.meta.env.VITE_CLIENT_BUGSNAG_API_KEY,
    appVersion,
    enabledReleaseStages: ['staging', 'production'],
    releaseStage:
      import.meta.env.VITE_CLIENT_BUGSNAG_RELEASE_STAGE || process.env.NODE_ENV,
    plugins: [new BugsnagPluginReact(React)]
  });

  const ErrorBoundary = Bugsnag.getPlugin('react');
  const loadingMessageEl = document.getElementById('js-loading-message');
  loadingMessageEl.parentNode.removeChild(loadingMessageEl);
  ReactDOM.render(
    <ErrorBoundary>
      <Provider store={store}>
        <Container />
      </Provider>
    </ErrorBoundary>,
    document.getElementById('app')
  );
});
